import { useLDClient } from 'launchdarkly-react-client-sdk';
import { createContext, useContext, useMemo } from 'react';

import { LoggingProviders, logger } from 'src/utils/logger';

type LoggerContextType = {
  debug: typeof logger.debug;
  error: typeof logger.error;
  getAllMiddleware: typeof logger.getAllMiddleware;
  info: typeof logger.info;
  setGlobalProperty: typeof logger.setGlobalProperty;
  warn: typeof logger.warn;
};

export const LoggerContext = createContext<LoggerContextType>({
  debug: logger.debug,
  error: logger.error,
  getAllMiddleware: logger.getAllMiddleware,
  info: logger.info,
  setGlobalProperty: logger.setGlobalProperty,
  warn: logger.warn,
});

export function useLogger() {
  const datadog = useContext(LoggerContext);
  return datadog;
}

export function LoggerProvider({ children }: { children: React.ReactNode }) {
  const logTool = useMemo(() => {
    logger.init({ turnOnForDevelopment: import.meta.env.DEV, providersToUse: LoggingProviders.ALL });
    return logger;
  }, []);

  return <LoggerContext.Provider value={logTool}>{children}</LoggerContext.Provider>;
}
